import * as iots from 'io-ts';
export const Nat = iots.brand(iots.number, (n) => Number.isInteger(n) && n >= 0, 'Nat');
export const zero = 0;
export const isNatD = (d) => d.name === 'Nat';
//# sourceMappingURL=nat.js.map